import axios from '../axios'
import qs from "qs";

function service(endpoint) {

    function audience(id, data) {
        return axios.get(`${endpoint}/${id}/audience`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        audience
    }
}

export default service
